import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PlatformLocation } from '@angular/common';
import { GlobalService } from '../../services/global.service';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from '../../services/user.service';
import { ApiService } from '../../services/api.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { PlayerService } from '../../services/player.service';
import { ScriptService } from '../../services/script.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import * as htmlToImage from 'html-to-image';
import domtoimage from 'dom-to-image-more';

import { DialogService } from 'src/app/services/dialog.service';

@Component({
    selector: 'sd-share-dialog',
    templateUrl: './share-dialog.component.html',
    styleUrls: ['./share-dialog.component.scss']
})

export class ShareDialogComponent implements OnInit, OnDestroy {

    type: String = '';
    slug: String = '';

    albumLoaded: Boolean = false;
    album: any;
    mainArtist: any;

    albumTracksLoaded: Boolean = false;

    tracksJson = [];
    slugsString = '';
    trackSlugs = [];

    iframeHeight = 185;

    mainVideoLoaded: Boolean = true;
    mainVideo: any;


    shareUrl: string = '';
    shareText: String = '';
    hashtags: String = 'WhereGreatMusicLives,Songdew';
    imageUrl: String = '';
    title: String = '';
    artist: String = '';
    description: String = '';
    imageToShow = '';
    imageToShowFb = '';

    currentTime = 0;
    totalDuration = 100;

    detailPrefix = '';

    downloadingCard: Boolean = false;

    quickfitLoaded = false;

    imgCdn = ""

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<ShareDialogComponent>,
        platformLocation: PlatformLocation,
        public global: GlobalService,
        private api: ApiService,
        public player: PlayerService,
        public user: UserService,
        public clipboard: Clipboard,
        private router: Router,
        public toastrService: ToastrService,
        public dialog: DialogService,

        private script: ScriptService
    ) {
        this.imageUrl = 'https://songdewnetwork.com/sgmedia/assets/images/homeogimage.jpg';
        // console.log(this.data);
        // console.log((platformLocation as any).location);
        // console.log((platformLocation as any).location.href);
        // console.log((platformLocation as any).location.origin);

        if (this.data.title != '') {
            this.title = this.data.title;
        }
        if (this.data.artist != '') {
            this.artist = this.data.artist;
        }
        this.type = this.data.type;
        this.slug = this.data.slug;

        if (this.data.type == 'song') {
            this.detailPrefix = this.global.songDetailPrefix;
            this.shareUrl = this.global.basePrefix + '/' + global.songDetailPrefix + '/' + this.data.slug;
            this.shareText = 'Hey There! Check out this amazing track ' + this.title + ' via @songdewnetwork';
            this.imageToShow = this.data.image;
            this.hashtags = 'WhereGreatMusicLives,Songdew';
            this.getSongDetails(this.slug);
        } else if (this.data.type == 'album') {
            this.detailPrefix = this.global.albumDetailPrefix;
            this.shareUrl = this.global.basePrefix + '/' + global.albumDetailPrefix + '/' + this.data.slug;
            this.shareText = 'Hey There! ' + this.artist + ' just dropped this new album ' + this.title + ' via @songdewnetwork';
            this.imageToShow = this.data.image;
            this.hashtags = 'HereItFirstOnSongdew,WhereGreatMusicLives';
            this.getAlbumDetails(this.slug);
        } else if (this.data.type == 'playlist') {
            this.detailPrefix = this.global.playlistDetailPrefix;
            this.shareUrl = this.global.basePrefix + '/' + global.playlistDetailPrefix + '/' + this.data.slug;
            this.shareText = 'Check out the amazing playlist ' + this.title + ' on Songdew';
            this.imageToShow = this.data.image;
            this.hashtags = 'WhereGreatMusicLives,Songdew';
            this.getPlaylistDetails(this.slug);
        } else if (this.data.type == 'video') {
            this.shareUrl = this.global.basePrefix + '/' + global.videoDetailPrefix + '/' + this.data.slug;
            this.shareText = 'Loved this video ' + this.title + ' by ' + this.artist + ' on Songdew';
            this.imageToShow = this.data.image;
            this.hashtags = 'WhereGreatMusicLives,Songdew';
            this.getVideoDetails(this.slug);
        } else if (this.data.type == 'opp') {
            this.shareUrl = this.global.basePrefix + '/' + global.oppDetailPrefix + '/' + this.data.slug;
            this.shareText = 'Checkout this amazing opportunity for all independent artists out there by Songdew';
            this.imageToShow = this.data.image;
            this.hashtags = 'Songdew,GetYourDue';
        } else if (this.data.type == 'blog') {
            this.shareUrl = this.global.basePrefix + '/' + global.blogDetailPrefix + '/' + this.data.slug;
            this.shareText = 'Loved this blog \'' + this.title + '\' on Songdew';
            this.imageToShow = this.data.image;
        } else if (this.data.type == 'album-review-card') {
            this.shareUrl = this.global.basePrefix + '/' + global.albumDetailPrefix + '/' + this.data.slug;
            this.shareText = this.artist + ' has reviewed an album ' + this.title + ' via @songdewnetwork';
            if (this.data.image != undefined && this.data.image != null && this.data.image.length > 0) {
                this.data.image.forEach(item => {
                    if (item.name == 'album_insta_review_card') {
                        this.imageToShow = item.card;
                    } else if (item.name == 'album_fb_review_card') {
                        this.imageToShowFb = item.card;
                    }
                });
            }
        } else if (this.data.type == 'song-review-card') {
            this.shareUrl = this.global.basePrefix + '/' + global.songDetailPrefix + '/' + this.data.slug;
            this.shareText = this.artist + ' has reviewed a track ' + this.title + ' via @songdewnetwork';
            if (this.data.image != undefined && this.data.image != null && this.data.image.length > 0) {
                this.data.image.forEach(item => {
                    if (item.name == 'song_insta_review_card') {
                        this.imageToShow = item.card;
                    } else if (item.name == 'song_fb_review_card') {
                        this.imageToShowFb = item.card;
                    }
                });
            }
        } else {
            this.shareUrl = this.global.basePrefix;
        }

        this.global.trackEvent('Share', 'popup-open', this.type + ' - ' + this.shareUrl);
    }

    ngOnInit() {
        const angularthis = this;

        if (angularthis.global.isBrowser) {
            const jp = $(angularthis.player.cssSelector.jPlayer), jpData = jp.data('jPlayer');

            this.script.load('quickfit').then(data => {
                this.quickfitLoaded = true;
                // console.log('quickfit loaded');
            }).catch(error => {
                this.quickfitLoaded = false;
                // console.log('quickfit loading error', error);
            });

            setInterval(function () {
                angularthis.currentTime = angularthis.roundOff(jpData.status.currentTime);
                angularthis.totalDuration = angularthis.roundOff(jpData.status.duration);

                if (angularthis.quickfitLoaded) {
                    (<any>$('.instaComment')).quickfit({ max: 16, min: 10, truncate: false, lines: 2 });
                }
            }, 1000);
        }

        this.data.customData.commentUserDp ? '' : this.data.customData.commentUserDp = 'https://songdewnetwork.com/sgmedia/assets/images/default-user.png'
    }

    changeSeekPos(event) {
        const angularthis = this;

        if (angularthis.global.isBrowser) {
            // console.log(event);
            angularthis.currentTime = event.value;
            (<any>$(angularthis.player.cssSelector.jPlayer)).jPlayer('play', event.value);
        }
    }

    roundOff(num) {
        return Math.round(num);
    }

    closeDialog() {
        this.dialogRef.close();
    }

    share() {
        // console.log(this.shareUrl);
        // console.log(this.title);
        // console.log(this.description);
        // console.log(this.imageToShow);
        // console.log(this.imageToShowFb);

        if (this.data.type == 'song-review-card' || this.data.type == 'album-review-card') {
            this.global.saveFile(this.imageToShowFb, 'Review Card');
        } else {
            let width = this.global.getOgSize(this.data.type, 0);
            let height = this.global.getOgSize(this.data.type, 1);

            (<any>window).FB.ui({
                method: 'share_open_graph',
                action_type: 'og.shares',
                action_properties: JSON.stringify({
                    object: {
                        'fb:app_id': '335931163095578',
                        'og:url': this.shareUrl, // your url to share
                        'og:title': this.title,
                        'og:description': this.description,
                        'og:image': this.imageToShow,
                        'og:image:width': width, // size of image in pixel
                        'og:image:height': height
                    }
                })
            }, function (response) {
                // console.log('response is ', response);
            });
        }
    }

    getSongDetails(slug) {
        this.albumLoaded = false;
        this.api.getSongDetails(slug).subscribe(res => {
            // console.log(res);

            if (res.success) {
                let genres = '';
                res.result.genre.forEach(genreName => {
                    genres = genreName.name;
                });
                let language = '';
                if (res.result.language.length > 0) {
                    language = res.result.language[0].name;
                }
                this.album = {
                    'id': res.result.id,
                    'isOwner': true,
                    'isPartOfAlbum': (res.result.album_id > 0) ? true : false,

                    'image': (res.result.album_id > 0) ? res.result.album.cover_pic : res.result.image,
                    'title': res.result.title,
                    'slug': res.result.slug_usersong,
                    'totalDuration': this.global.sec2Min(res.result.duration),
                    'genres': [genres],
                    'language': language,
                    'plays': res.result.song_plays,
                    'description': res.result.description,
                    'releasedDate': this.global.formatedDate(res.result.created_date),
                    'publishedDate': this.global.formatedDate(res.result.created_date),
                    'tracks': [res.result],

                    'clapsCount': res.result.is_like,
                    'totalClapsCount': res.result.song_likes,
                    'isDownloadable': res.result.is_downloadable,
                    'isPaid': res.result.is_paid,
                    'buylink': res.result.buylink,
                    'price': res.result.price,
                    'sku': res.result.sku,

                    'scheduled': false,

                    'lyrics': res.result.lyrics,
                    'privacy': (!res.result.is_public && !res.result.is_scheduled) ? true : false,

                    'isVariousArtists': false
                };

                this.mainArtist = {
                    'isSameArtist': res.result.artist_id.is_same_artist,
                    'slug': res.result.artist_id.slug_username,
                    'dp': res.result.artist_id.profile.profile_pic,
                    'fname': res.result.artist_id.profile.first_name,
                    'lname': res.result.artist_id.profile.last_name,
                    'name': res.result.artist_id.profile.first_name + ' ' + res.result.artist_id.profile.last_name,
                    'followersCount': res.result.artist_id.followers_count,
                    'isFollowing': res.result.artist_id.is_following
                };

                if (this.album.privacy && this.mainArtist.slug != this.user.slug) {
                    this.router.navigate(['/404.html']);
                }

                this.albumLoaded = true;

                this.album.tracks.forEach(track => {
                    this.tracksJson.push({
                        'title': track.title,
                        'artist': track.user.profile.first_name + ' ' + track.user.profile.last_name,
                        'artistSlug': track.user.slug_username,
                        'mp3': track.song_file,
                        'image': this.album.image,
                        'slug': track.slug_usersong,
                        'clapsCount': this.album.clapsCount,
                        'totalClapsCount': this.album.totalClapsCount
                    });

                    this.slugsString += ' playsCount_' + track.slug_usersong;
                    this.trackSlugs.push(track.slug_usersong);
                });

                if (res.result.album_id > 0) {
                    this.album.albumSlug = res.result.album.slug_album;

                    this.api.getAlbumDetails(res.result.album.slug_album).subscribe(res2 => {
                        console.log(res);

                        if (res2.success) {
                            this.albumTracksLoaded = true;
                            const albumImage = res2.data.cover_pic;

                            res2.data.music_tracks.forEach(track => {
                                if (track.slug_usersong != this.album.slug) {
                                    this.tracksJson.push({
                                        'title': track.title,
                                        'artist': track.user.profile.first_name + ' ' + track.user.profile.last_name,
                                        'artistSlug': track.user.slug_username,
                                        'mp3': track.song_file,
                                        'image': albumImage,
                                        'slug': track.slug_usersong,
                                        'clapsCount': track.is_like,
                                        'totalClapsCount': track.song_likes
                                    });

                                    this.slugsString += ' playsCount_' + track.slug_usersong;
                                    this.trackSlugs.push(track.slug_usersong);

                                    this.album.tracks.push(track);
                                    this.album.tracks[this.album.tracks.length - 1].image = albumImage;
                                }
                            });
                        } else {
                            // console.log(res.error);
                        }
                    },
                        (err: HttpErrorResponse) => {
                            this.albumTracksLoaded = false;
                            if (err.error instanceof Error) {
                                // console.log('Client-side error occured!');
                            } else {
                                // console.log('Server-side error occured!', err);
                            }
                        });
                } else {
                    //
                }
            } else {
                // console.log(res.error);
            }
        },
            (err: HttpErrorResponse) => {
                this.albumLoaded = false;
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }
            });
    }

    getAlbumDetails(slug) {
        this.albumLoaded = false;
        this.api.getAlbumDetails(slug).subscribe(res => {
            console.log(res);

            if (res.success) {
                let genres = [''];
                let languages = [''];

                res.data.genre_id.forEach(genreName => {
                    // genres.push(genreName.name);
                    genres = [genreName.name];
                });
                res.data.language_id.forEach(langName => {
                    languages.push(langName.name);
                });

                this.album = {
                    'id': res.data.id,
                    'isOwner': res.data.is_owner,
                    'image': res.data.cover_pic,
                    'title': res.data.title,
                    'slug': res.data.slug_album,
                    'totalDuration': this.global.sec2Min(res.data.total_duration),
                    'genres': genres,
                    'language': languages,
                    'plays': res.data.play_count,
                    'description': res.data.about_band,
                    'releasedDate': this.global.formatedDate(res.data.created_date),
                    'publishedDate': this.global.formatedDate(res.data.created_date),
                    'tracks': res.data.music_tracks,

                    'clapsCount': res.data.is_like,
                    'totalClapsCount': res.data.likes_count,
                    'isDownloadable': res.data.is_digital,
                    'isPaid': (res.data.album_price > 0) ? true : false,
                    'buylink': '',
                    'price': res.data.album_price,
                    'sku': res.data.sku,

                    'scheduled': res.data.is_scheduled,
                    'privacy': (!res.data.is_public && !res.data.is_scheduled) ? true : false,

                    'isVariousArtists': false
                };
                this.mainArtist = {
                    'isSameArtist': (res.data.artists.length > 0) ? res.data.artists[0].is_same_artist : false,
                    'slug': (res.data.artists.length > 0) ? res.data.artists[0].slug_username : '',
                    'dp': (res.data.artists.length > 0) ? res.data.artists[0].profile_pic : '',
                    'fname': (res.data.artists.length > 0) ? res.data.artists[0].first_name : '',
                    'lname': (res.data.artists.length > 0) ? res.data.artists[0].last_name : '',
                    'name': (res.data.artists.length > 0) ? res.data.artists[0].full_name : '',
                    'followersCount': (res.data.artists.length > 0) ? res.data.artists[0].followers_count : 0,
                    'isFollowing': (res.data.artists.length > 0) ? res.data.artists[0].is_following : 0
                };

                if (this.album.privacy && this.mainArtist.slug != this.user.slug) {
                    this.router.navigate(['/404.html']);
                }

                this.albumLoaded = true;

                let trackNum = 0;
                this.album.tracks.forEach(track => {
                    this.tracksJson.push({
                        'title': track.title,
                        'artist': track.user.profile.first_name + ' ' + track.user.profile.last_name,
                        'artistSlug': track.user.slug_username,
                        'mp3': track.song_file,
                        'image': this.album.image,
                        'slug': track.slug_usersong,
                        'clapsCount': track.is_like,
                        'totalClapsCount': track.song_likes
                    });

                    this.slugsString += ' playsCount_' + track.slug_usersong;
                    this.trackSlugs.push(track.slug_usersong);

                    this.album.tracks[trackNum].image = this.album.image;

                    trackNum++;
                });
            } else {
                // console.log(res.error);
            }
        },
            (err: HttpErrorResponse) => {
                this.albumLoaded = false;
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }
            });
    }

    getPlaylistDetails(slug) {
        this.albumLoaded = false;
        this.api.getPlaylistDetails(slug).subscribe(res => {
            // console.log(res);

            this.album = {
                'id': res.id,
                'isOwner': true,
                'image': res.cover_pic,
                'title': res.title,
                'slug': res.slug_playlist,
                'totalDuration': this.global.sec2Min(res.playlist_duration),
                'plays': res.playlist_plays,
                'description': res.description,
                'releasedDate': this.global.formatedDate(res.created_date),
                'publishedDate': this.global.formatedDate(res.created_date),
                'tracks': res.track,

                'clapsCount': res.is_like,
                'totalClapsCount': res.playlist_likes,
                'isDownloadable': false,

                'scheduled': false,
                'privacy': !res.status,

                'isVariousArtists': false
            };
            this.mainArtist = {
                'isSameArtist': res.user.is_same_artist,
                'slug': res.user.slug_username,
                'dp': res.user.profile.profile_pic,
                'fname': res.user.profile.first_name,
                'lname': res.user.profile.last_name,
                'followersCount': res.user.followers_count,
                'isFollowing': res.user.is_following
            };

            if (this.album.privacy && this.mainArtist.slug != this.user.slug) {
                this.router.navigate(['/404.html']);
            }

            this.albumLoaded = true;

            let artists = [];
            this.album.tracks.forEach(track => {
                this.tracksJson.push({
                    'title': track.title,
                    'artist': track.artist_id.profile.first_name + ' ' + track.artist_id.profile.last_name,
                    'artistSlug': track.artist_id.slug_username,
                    'mp3': track.song_file,
                    'image': track.image,
                    'slug': track.slug_usersong,
                    'clapsCount': track.is_like,
                    'totalClapsCount': track.song_likes
                });

                let alreadyAdded = false;
                artists.forEach(artist => {
                    if (artist.slug == track.artist_id.slug_username) {
                        alreadyAdded = true;
                    }
                });
                if (!alreadyAdded) {
                    artists.push({
                        'dp': track.artist_id.profile.profile_pic,
                        'name': track.artist_id.profile.first_name + ' ' + track.artist_id.profile.last_name,
                        'slug': track.artist_id.slug_username,
                        'artist_type': track.artist_id.artist_type,
                        'is_type': track.artist_id.is_type,
                        'isFollowing': track.artist_id.is_following
                    });
                }

                this.slugsString += ' playsCount_' + track.slug_usersong;
                this.trackSlugs.push(track.slug_usersong);
            });

            this.album.artists = artists;

            if ((this.album.image == '' || this.album.image == null) &&
                this.album.tracks.length > 0 &&
                (this.album.tracks[0].image != '' && this.album.tracks[0].image != null)
            ) {
                this.album.image = this.album.tracks[0].image;
            }
        },
            (err: HttpErrorResponse) => {
                this.albumLoaded = false;
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }
            });
    }

    getVideoDetails(slug) {
        this.iframeHeight = 657;
        this.mainVideoLoaded = false;

        this.api.getVideoDetails(slug).subscribe(res => {
            // console.log(res);

            this.mainVideo = {
                'title': res.result.title,
                'slug': res.result.slug_uservideo,
                'YTID': res.result.youtube_video_id,
                'artist': res.result.user.profile.first_name + ' ' + res.result.user.profile.last_name,
                'artistSlug': res.result.user.slug_username,
                'image': res.result.img_640x480
            };

            if (this.mainVideo.privacy && this.mainVideo.artistSlug != this.user.slug) {
                this.router.navigate(['/404.html']);
            }

            this.mainVideoLoaded = true;

            const angularthis = this;

            var mainVideoElemEmbed;

            // Loads the IFrame Player API code asynchronously
            function loadScript() {
                if (typeof (window['YT']) == 'undefined' || typeof (window['YT'].Player) == 'undefined') {
                    var tag = document.createElement('script');
                    tag.id = 'iframe-demo';
                    tag.src = 'https://www.youtube.com/iframe_api';
                    var firstScriptTag = document.getElementsByTagName('script')[0];
                    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
                }
            }

            function onPlayerReady(event) {
                // console.log('player ready', event);
            }

            function onPlayerStateChange(event) {
                // console.log('state change', event);

                if (event.data == 0) {
                    mainVideoElemEmbed.stopVideo();
                }
            }

            if (angularthis.global.isBrowser) {
                $(document).ready(function () {
                    loadScript();

                    if (window['onYouTubeIframeAPIReady']) {
                        // console.log('YouTube API is already ready');

                        mainVideoElemEmbed = new window['YT'].Player('mainVideoElemEmbed', {
                            height: '390',
                            width: '640',
                            videoId: angularthis.mainVideo.YTID,
                            playerVars: { 'rel': 0, 'showsearch': 0, 'autohide': 2, 'autoplay': 1, 'controls': 1, 'fs': 1, 'loop': 0, 'showinfo': 1, 'color': 'red', 'theme': 'light', 'wmode': 'transparent' },
                            events: {
                                'onReady': onPlayerReady,
                                'onStateChange': onPlayerStateChange
                            }
                        });
                    } else {
                        window['onYouTubeIframeAPIReady'] = function () {
                            // console.log('YouTube API Ready');

                            mainVideoElemEmbed = new window['YT'].Player('mainVideoElemEmbed', {
                                height: '390',
                                width: '640',
                                videoId: angularthis.mainVideo.YTID,
                                playerVars: { 'rel': 0, 'showsearch': 0, 'autohide': 2, 'autoplay': 1, 'controls': 1, 'fs': 1, 'loop': 0, 'showinfo': 1, 'color': 'red', 'theme': 'light', 'wmode': 'transparent' },
                                events: {
                                    'onReady': onPlayerReady,
                                    'onStateChange': onPlayerStateChange
                                }
                            });
                        }
                    }
                });
            }
        },
            (err: HttpErrorResponse) => {
                this.mainVideoLoaded = false;
                if (err.error instanceof Error) {
                    // console.log('Client-side error occured!');
                } else {
                    // console.log('Server-side error occured!', err);
                }
            });
    }

    ngOnDestroy() {
        // console.log('destroy');
    }

    downloadCard(id, name) {
        const angularthis = this;
        angularthis.downloadingCard = true;
       /* htmlToImage.toBlob(document.getElementById(id))
            .then(function (blob) {
                window.saveAs(blob, name);
                angularthis.downloadingCard = false;
            });*/
            const node = document.getElementById(id);

                const scale = 3; // or 3 for higher DPI
                const style = {
                transform: 'scale(' + scale + ')',
                transformOrigin: 'top left',
                width: node.scrollWidth + 'px',
                height: node.scrollHeight + 'px',
                };

                domtoimage.toPng(node, {
                    width: node.scrollWidth * scale,
                    height: node.scrollHeight * scale,
                    style,
                })
                .then(dataUrl => {
                    const link = document.createElement('a');
                    link.download = name+'.png';
                    link.href = dataUrl;
                    link.click();
                    angularthis.downloadingCard = false;
                    angularthis.global.globalSpinner = false;
                       
                })
                .catch(error => {
                console.error('🔥 Image generation failed:', error);
                angularthis.downloadingCard = false;
                 angularthis.global.globalSpinner = false;
                });
    }
}
